import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { Subscription } from 'rxjs';

import { SubscriptionSearchService } from '~/attendee/service/subscription-search.service';
import { BackLinkInterface } from '~/checkout/interfaces/back-link.interface';
import { Activity } from '~/core/model/activity.model';
import { Timeslot } from '~/core/model/timeslot.model';
import { ActivityService } from '~/core/services/activity/activity.service';
import { MatchMediaService } from '~/core/services/match-media/match-media.service';

@Component({
  selector: 'app-organizer-activity-timeslot-dates',
  templateUrl: './dates.component.html',
  styleUrls: ['./dates.component.scss'],
})
export class OrganizerActivityDatesPageComponent implements OnInit {
  private readonly subscription = new Subscription();

  private isTabletDevice: boolean;
  private page = 1;

  public activity: Activity;
  public hasLoadMoreButton: boolean;
  public hasPagination: boolean;
  public timeslots: Timeslot[];

  constructor(
    private readonly matchMediaService: MatchMediaService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly localizeRouterService: LocalizeRouterService,
    private readonly activityService: ActivityService,
    private readonly subscriptionSearchService: SubscriptionSearchService
  ) {}

  public ngOnInit(): void {
    this.activatedRoute.data.subscribe(({ activityAndTimeslotsData }) => {
      this.activity = activityAndTimeslotsData.activity;
      this.timeslots = activityAndTimeslotsData.timeslots;
      this.hasPagination = this.timeslots?.length >= 5;
      this.hasLoadMoreButton = this.hasPagination;
    });

    this.subscription.add(
      this.matchMediaService.isTabletDevice().subscribe((isTabletDevice) => {
        this.isTabletDevice = isTabletDevice;
      })
    );
  }

  public get backLink(): BackLinkInterface {
    return {
      path: `${this.localizeRouterService
        .translateRoute('/organizer.activity.manage')
        .toString()}/${this.activity.sku}`,
    };
  }

  public get hasHeader(): boolean {
    return !this.isTabletDevice;
  }

  public loadMore(): void {
    this.page += 1;

    this.activityService
      .getActivityTimeslots(
        this.activity?.sku?.toString(),
        this.subscriptionSearchService.getTimeslotsFilters(),
        this.page,
        20
      )
      .subscribe((timeslots) => {
        this.timeslots = this.timeslots?.concat(timeslots);
        this.hasLoadMoreButton = timeslots?.length === 20;
      });
  }
}
